export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const GET_ERRORS = "GET_ERRORS";
export const returnErrors = (msg, status, id = null) => {
  return {
    type: GET_ERRORS,
    payload: { msg, status, id },
  };
};
export const clearErrors = (msg, status, id = null) => {
  return {
    type: CLEAR_ERRORS,
    payload: { msg, status, id },
  };
};
